import { ITimeOption } from '../../../../types/interfaceextension'

export const reduceTimeOptions = (
    timeOptions: ITimeOption[],
    beforeOrAfterSelected: 'Before' | 'After',
    selectedOption?: string
): ITimeOption[] => {
    const reduced: ITimeOption[] = timeOptions.reduce((prev, cur) => {
        if (selectedOption === undefined) {
            prev.push(cur)
            const res = [...prev]
            return res
        } else {
            const isBefore = beforeOrAfterSelected === 'Before'
            const currentValue = parseInt(cur.value)
            const selectedValue = parseInt(selectedOption)

            const isAvailableOption =
                (isBefore && currentValue < selectedValue) ||
                (!isBefore && currentValue > selectedValue)

            if (isAvailableOption) {
                prev.push(cur)
            }

            const res = [...prev]
            return res
        }
    }, [] as ITimeOption[])
    return reduced
}
